import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface AddCourseToCandidateResponse extends BackendResponse {}
export interface AddCourseToCandidateParameters extends NextApiParams {
  from: string;
  to: string;
  candidateId: number;
  organizer: string;
  courseType: number;
  references: string;
  comment: string;
  level: number;
  expirationDate: string;
  duplicateCheck: boolean;
}

export const addCourseToCandidate = withNextApi<
  AddCourseToCandidateResponse,
  AddCourseToCandidateParameters
>("/cvp/CvpAddCourseToCandidate");
